module.exports = __webpack_public_path__ + "static/img/runningwild-details.c5a9705b.jpg";